import { library, dom } from "@fortawesome/fontawesome-svg-core";

import { faAddressCard } from "@fortawesome/pro-regular-svg-icons/faAddressCard";
import { faAngleDown } from "@fortawesome/pro-regular-svg-icons/faAngleDown";
import { faAngleLeft } from "@fortawesome/pro-regular-svg-icons/faAngleLeft";
import { faAngleUp } from "@fortawesome/pro-regular-svg-icons/faAngleUp";
import { faArrowLeft } from "@fortawesome/pro-regular-svg-icons/faArrowLeft";
import { faArrowLeftLong } from "@fortawesome/pro-regular-svg-icons/faArrowLeftLong";
import { faArrowRight } from "@fortawesome/pro-regular-svg-icons/faArrowRight";
import { faArrowRightArrowLeft } from "@fortawesome/pro-regular-svg-icons/faArrowRightArrowLeft";
import { faArrowRotateLeft } from "@fortawesome/pro-regular-svg-icons/faArrowRotateLeft";
import { faArrowUp } from "@fortawesome/pro-regular-svg-icons/faArrowUp";
import { faArrowsRotate } from "@fortawesome/pro-regular-svg-icons/faArrowsRotate";
import { faAt } from "@fortawesome/pro-regular-svg-icons/faAt";
import { faBan } from "@fortawesome/pro-regular-svg-icons/faBan";
import { faBank } from "@fortawesome/pro-regular-svg-icons/faBank";
import { faBarcode } from "@fortawesome/pro-regular-svg-icons/faBarcode";
import { faBars } from "@fortawesome/pro-regular-svg-icons/faBars";
import { faBell } from "@fortawesome/pro-regular-svg-icons/faBell";
import { faBolt } from "@fortawesome/pro-regular-svg-icons/faBolt";
import { faBook } from "@fortawesome/pro-regular-svg-icons/faBook";
import { faBoxArchive } from "@fortawesome/pro-regular-svg-icons/faBoxArchive";
import { faBriefcase } from "@fortawesome/pro-regular-svg-icons/faBriefcase";
import { faBuilding } from "@fortawesome/pro-regular-svg-icons/faBuilding";
import { faBullhorn } from "@fortawesome/pro-regular-svg-icons/faBullhorn";
import { faCalendarDays } from "@fortawesome/pro-regular-svg-icons/faCalendarDays";
import { faCamera } from "@fortawesome/pro-regular-svg-icons/faCamera";
import { faCaretDown } from "@fortawesome/pro-regular-svg-icons/faCaretDown";
import { faCaretUp } from "@fortawesome/pro-regular-svg-icons/faCaretUp";
import { faChartLine } from "@fortawesome/pro-regular-svg-icons/faChartLine";
import { faChartPie } from "@fortawesome/pro-regular-svg-icons/faChartPie";
import { faCheck } from "@fortawesome/pro-regular-svg-icons/faCheck";
import { faChevronDown } from "@fortawesome/pro-regular-svg-icons/faChevronDown";
import { faChevronLeft } from "@fortawesome/pro-regular-svg-icons/faChevronLeft";
import { faChevronRight } from "@fortawesome/pro-regular-svg-icons/faChevronRight";
import { faChevronUp } from "@fortawesome/pro-regular-svg-icons/faChevronUp";
import { faChevronsDown } from "@fortawesome/pro-regular-svg-icons/faChevronsDown";
import { faCircle } from "@fortawesome/pro-regular-svg-icons/faCircle";
import { faCircleArrowDown } from "@fortawesome/pro-regular-svg-icons/faCircleArrowDown";
import { faCircleArrowRight } from "@fortawesome/pro-regular-svg-icons/faCircleArrowRight";
import { faCircleArrowUp } from "@fortawesome/pro-regular-svg-icons/faCircleArrowUp";
import { faCircleCheck } from "@fortawesome/pro-regular-svg-icons/faCircleCheck";
import { faCircleChevronDown } from "@fortawesome/pro-regular-svg-icons/faCircleChevronDown";
import { faCircleChevronRight } from "@fortawesome/pro-regular-svg-icons/faCircleChevronRight";
import { faCircleExclamation } from "@fortawesome/pro-regular-svg-icons/faCircleExclamation";
import { faCircleInfo } from "@fortawesome/pro-regular-svg-icons/faCircleInfo";
import { faCircleMinus } from "@fortawesome/pro-regular-svg-icons/faCircleMinus";
import { faCircleNotch } from "@fortawesome/pro-regular-svg-icons/faCircleNotch";
import { faCirclePlus } from "@fortawesome/pro-regular-svg-icons/faCirclePlus";
import { faCircleQuestion } from "@fortawesome/pro-regular-svg-icons/faCircleQuestion";
import { faCircleUser } from "@fortawesome/pro-regular-svg-icons/faCircleUser";
import { faCircleX } from "@fortawesome/pro-regular-svg-icons/faCircleX";
import { faCircleXmark } from "@fortawesome/pro-regular-svg-icons/faCircleXmark";
import { faClipboardCheck } from "@fortawesome/pro-regular-svg-icons/faClipboardCheck";
import { faClock } from "@fortawesome/pro-regular-svg-icons/faClock";
import { faCoins } from "@fortawesome/pro-regular-svg-icons/faCoins";
import { faComment } from "@fortawesome/pro-regular-svg-icons/faComment";
import { faComments } from "@fortawesome/pro-regular-svg-icons/faComments";
import { faCopy } from "@fortawesome/pro-regular-svg-icons/faCopy";
import { faCreditCard } from "@fortawesome/pro-regular-svg-icons/faCreditCard";
import { faDownload } from "@fortawesome/pro-regular-svg-icons/faDownload";
import { faEllipsis } from "@fortawesome/pro-regular-svg-icons/faEllipsis";
import { faEnvelope } from "@fortawesome/pro-regular-svg-icons/faEnvelope";
import { faExclamationCircle } from "@fortawesome/pro-regular-svg-icons/faExclamationCircle";
import { faEye } from "@fortawesome/pro-regular-svg-icons/faEye";
import { faEyeSlash } from "@fortawesome/pro-regular-svg-icons/faEyeSlash";
import { faFaceLaughBeam } from "@fortawesome/pro-regular-svg-icons/faFaceLaughBeam";
import { faFaceLaughWink } from "@fortawesome/pro-regular-svg-icons/faFaceLaughWink";
import { faFileLines } from "@fortawesome/pro-regular-svg-icons/faFileLines";
import { faFileMagnifyingGlass } from "@fortawesome/pro-regular-svg-icons/faFileMagnifyingGlass";
import { faFilter } from "@fortawesome/pro-regular-svg-icons/faFilter";
import { faFlag } from "@fortawesome/pro-regular-svg-icons/faFlag";
import { faFloppyDisk } from "@fortawesome/pro-regular-svg-icons/faFloppyDisk";
import { faGaugeMax } from "@fortawesome/pro-regular-svg-icons/faGaugeMax";
import { faGavel } from "@fortawesome/pro-regular-svg-icons/faGavel";
import { faGear } from "@fortawesome/pro-regular-svg-icons/faGear";
import { faGears } from "@fortawesome/pro-regular-svg-icons/faGears";
import { faGift } from "@fortawesome/pro-regular-svg-icons/faGift";
import { faGlobe } from "@fortawesome/pro-regular-svg-icons/faGlobe";
import { faGripLinesVertical } from "@fortawesome/pro-regular-svg-icons/faGripLinesVertical";
import { faHandshake } from "@fortawesome/pro-regular-svg-icons/faHandshake";
import { faHeart } from "@fortawesome/pro-regular-svg-icons/faHeart";
import { faHouse } from "@fortawesome/pro-regular-svg-icons/faHouse";
import { faImage } from "@fortawesome/pro-regular-svg-icons/faImage";
import { faInfo } from "@fortawesome/pro-regular-svg-icons/faInfo";
import { faLifeRing } from "@fortawesome/pro-regular-svg-icons/faLifeRing";
import { faLink } from "@fortawesome/pro-regular-svg-icons/faLink";
import { faList } from "@fortawesome/pro-regular-svg-icons/faList";
import { faLocationCrosshairs } from "@fortawesome/pro-regular-svg-icons/faLocationCrosshairs";
import { faLocationDot } from "@fortawesome/pro-regular-svg-icons/faLocationDot";
import { faLock } from "@fortawesome/pro-regular-svg-icons/faLock";
import { faLockKeyhole } from "@fortawesome/pro-regular-svg-icons/faLockKeyhole";
import { faMagnifyingGlass } from "@fortawesome/pro-regular-svg-icons/faMagnifyingGlass";
import { faMartiniGlassCitrus } from "@fortawesome/pro-regular-svg-icons/faMartiniGlassCitrus";
import { faMemory } from "@fortawesome/pro-regular-svg-icons/faMemory";
import { faMinus } from "@fortawesome/pro-regular-svg-icons/faMinus";
import { faMobile } from "@fortawesome/pro-regular-svg-icons/faMobile";
import { faMobileScreenButton } from "@fortawesome/pro-regular-svg-icons/faMobileScreenButton";
import { faMoneyBillWave } from "@fortawesome/pro-regular-svg-icons/faMoneyBillWave";
import { faNoteSticky } from "@fortawesome/pro-regular-svg-icons/faNoteSticky";
import { faPaperPlane } from "@fortawesome/pro-regular-svg-icons/faPaperPlane";
import { faPen } from "@fortawesome/pro-regular-svg-icons/faPen";
import { faPenToSquare } from "@fortawesome/pro-regular-svg-icons/faPenToSquare";
import { faPencil } from "@fortawesome/pro-regular-svg-icons/faPencil";
import { faPercent } from "@fortawesome/pro-regular-svg-icons/faPercent";
import { faPhone } from "@fortawesome/pro-regular-svg-icons/faPhone";
import { faPlay } from "@fortawesome/pro-regular-svg-icons/faPlay";
import { faPlus } from "@fortawesome/pro-regular-svg-icons/faPlus";
import { faPowerOff } from "@fortawesome/pro-regular-svg-icons/faPowerOff";
import { faQuestion } from "@fortawesome/pro-regular-svg-icons/faQuestion";
import { faQuoteRight } from "@fortawesome/pro-regular-svg-icons/faQuoteRight";
import { faReceipt } from "@fortawesome/pro-regular-svg-icons/faReceipt";
import { faRepeat } from "@fortawesome/pro-regular-svg-icons/faRepeat";
import { faReply } from "@fortawesome/pro-regular-svg-icons/faReply";
import { faRetweet } from "@fortawesome/pro-regular-svg-icons/faRetweet";
import { faRightFromBracket } from "@fortawesome/pro-regular-svg-icons/faRightFromBracket";
import { faRocket } from "@fortawesome/pro-regular-svg-icons/faRocket";
import { faRocketLaunch } from "@fortawesome/pro-regular-svg-icons/faRocketLaunch";
import { faRotateLeft } from "@fortawesome/pro-regular-svg-icons/faRotateLeft";
import { faScrewdriverWrench } from "@fortawesome/pro-regular-svg-icons/faScrewdriverWrench";
import { faShare } from "@fortawesome/pro-regular-svg-icons/faShare";
import { faShieldCheck } from "@fortawesome/pro-regular-svg-icons/faShieldCheck";
import { faShippingFast } from "@fortawesome/pro-regular-svg-icons/faShippingFast";
import { faSortDown } from "@fortawesome/pro-regular-svg-icons/faSortDown";
import { faSpinner } from "@fortawesome/pro-regular-svg-icons/faSpinner";
import { faSquare } from "@fortawesome/pro-regular-svg-icons/faSquare";
import { faSquareCheck } from "@fortawesome/pro-regular-svg-icons/faSquareCheck";
import { faSquareQuestion } from "@fortawesome/pro-regular-svg-icons/faSquareQuestion";
import { faStar } from "@fortawesome/pro-regular-svg-icons/faStar";
import { faSuitcase } from "@fortawesome/pro-regular-svg-icons/faSuitcase";
import { faTableCells } from "@fortawesome/pro-regular-svg-icons/faTableCells";
import { faTag } from "@fortawesome/pro-regular-svg-icons/faTag";
import { faThumbsDown } from "@fortawesome/pro-regular-svg-icons/faThumbsDown";
import { faThumbsUp } from "@fortawesome/pro-regular-svg-icons/faThumbsUp";
import { faTrashCan } from "@fortawesome/pro-regular-svg-icons/faTrashCan";
import { faTriangleExclamation } from "@fortawesome/pro-regular-svg-icons/faTriangleExclamation";
import { faTrophy } from "@fortawesome/pro-regular-svg-icons/faTrophy";
import { faTruckFast } from "@fortawesome/pro-regular-svg-icons/faTruckFast";
import { faTruckMedical } from "@fortawesome/pro-regular-svg-icons/faTruckMedical";
import { faUnlock } from "@fortawesome/pro-regular-svg-icons/faUnlock";
import { faUnlockKeyhole } from "@fortawesome/pro-regular-svg-icons/faUnlockKeyhole";
import { faUser } from "@fortawesome/pro-regular-svg-icons/faUser";
import { faUserPlus } from "@fortawesome/pro-regular-svg-icons/faUserPlus";
import { faUserTag } from "@fortawesome/pro-regular-svg-icons/faUserTag";
import { faUsers } from "@fortawesome/pro-regular-svg-icons/faUsers";
import { faWallet } from "@fortawesome/pro-regular-svg-icons/faWallet";
import { faWarning } from "@fortawesome/pro-regular-svg-icons/faWarning";
import { faWheelchair } from "@fortawesome/pro-regular-svg-icons/faWheelchair";
import { faWrench } from "@fortawesome/pro-regular-svg-icons/faWrench";
import { faXmark } from "@fortawesome/pro-regular-svg-icons/faXmark";
import { faFileSlash } from "@fortawesome/pro-regular-svg-icons/faFileSlash";
import { faFileContract } from "@fortawesome/pro-regular-svg-icons/faFileContract";
import { faMessagesQuestion } from "@fortawesome/pro-regular-svg-icons/faMessagesQuestion";
import { faSparkles } from "@fortawesome/pro-regular-svg-icons/faSparkles";
import { faHandHoldingDollar } from "@fortawesome/pro-regular-svg-icons/faHandHoldingDollar";
import { faMoneyBillTrendUp } from "@fortawesome/pro-regular-svg-icons/faMoneyBillTrendUp";
import { faEuroSign } from "@fortawesome/pro-regular-svg-icons/faEuroSign";
import { faArrowsRepeat } from "@fortawesome/pro-regular-svg-icons/faArrowsRepeat";

document.addEventListener("DOMContentLoaded", () => {
  library.add(faAddressCard);
  library.add(faAngleDown);
  library.add(faAngleLeft);
  library.add(faAngleUp);
  library.add(faArrowLeft);
  library.add(faArrowLeftLong);
  library.add(faArrowRight);
  library.add(faArrowRightArrowLeft);
  library.add(faArrowRotateLeft);
  library.add(faArrowUp);
  library.add(faArrowsRotate);
  library.add(faAt);
  library.add(faBan);
  library.add(faBank);
  library.add(faBarcode);
  library.add(faBars);
  library.add(faBell);
  library.add(faBolt);
  library.add(faBook);
  library.add(faBoxArchive);
  library.add(faBriefcase);
  library.add(faBuilding);
  library.add(faBullhorn);
  library.add(faCalendarDays);
  library.add(faCamera);
  library.add(faCaretDown);
  library.add(faCaretUp);
  library.add(faChartLine);
  library.add(faChartPie);
  library.add(faCheck);
  library.add(faChevronDown);
  library.add(faChevronLeft);
  library.add(faChevronRight);
  library.add(faChevronUp);
  library.add(faChevronsDown);
  library.add(faCircle);
  library.add(faCircleArrowDown);
  library.add(faCircleArrowRight);
  library.add(faCircleArrowUp);
  library.add(faCircleCheck);
  library.add(faCircleChevronDown);
  library.add(faCircleChevronRight);
  library.add(faCircleExclamation);
  library.add(faCircleInfo);
  library.add(faCircleMinus);
  library.add(faCircleNotch);
  library.add(faCirclePlus);
  library.add(faCircleQuestion);
  library.add(faCircleUser);
  library.add(faCircleX);
  library.add(faCircleXmark);
  library.add(faClipboardCheck);
  library.add(faClock);
  library.add(faCoins);
  library.add(faComment);
  library.add(faComments);
  library.add(faCopy);
  library.add(faCreditCard);
  library.add(faDownload);
  library.add(faEllipsis);
  library.add(faEnvelope);
  library.add(faExclamationCircle);
  library.add(faEye);
  library.add(faEyeSlash);
  library.add(faFaceLaughBeam);
  library.add(faFaceLaughWink);
  library.add(faFileLines);
  library.add(faFileMagnifyingGlass);
  library.add(faFilter);
  library.add(faFlag);
  library.add(faFloppyDisk);
  library.add(faGaugeMax);
  library.add(faGavel);
  library.add(faGear);
  library.add(faGears);
  library.add(faGift);
  library.add(faGlobe);
  library.add(faGripLinesVertical);
  library.add(faHandshake);
  library.add(faHeart);
  library.add(faHouse);
  library.add(faImage);
  library.add(faInfo);
  library.add(faLifeRing);
  library.add(faLink);
  library.add(faList);
  library.add(faLocationCrosshairs);
  library.add(faLocationDot);
  library.add(faLock);
  library.add(faLockKeyhole);
  library.add(faMagnifyingGlass);
  library.add(faMartiniGlassCitrus);
  library.add(faMemory);
  library.add(faMinus);
  library.add(faMobile);
  library.add(faMobileScreenButton);
  library.add(faMoneyBillWave);
  library.add(faNoteSticky);
  library.add(faPaperPlane);
  library.add(faPen);
  library.add(faPenToSquare);
  library.add(faPencil);
  library.add(faPercent);
  library.add(faPhone);
  library.add(faPlay);
  library.add(faPlus);
  library.add(faPowerOff);
  library.add(faQuestion);
  library.add(faQuoteRight);
  library.add(faReceipt);
  library.add(faRepeat);
  library.add(faReply);
  library.add(faRetweet);
  library.add(faRightFromBracket);
  library.add(faRocket);
  library.add(faRocketLaunch);
  library.add(faRotateLeft);
  library.add(faScrewdriverWrench);
  library.add(faShare);
  library.add(faShieldCheck);
  library.add(faShippingFast);
  library.add(faSortDown);
  library.add(faSpinner);
  library.add(faSquare);
  library.add(faSquareCheck);
  library.add(faSquareQuestion);
  library.add(faStar);
  library.add(faSuitcase);
  library.add(faTableCells);
  library.add(faTag);
  library.add(faThumbsDown);
  library.add(faThumbsUp);
  library.add(faTrashCan);
  library.add(faTriangleExclamation);
  library.add(faTrophy);
  library.add(faTruckFast);
  library.add(faTruckMedical);
  library.add(faUnlock);
  library.add(faUnlockKeyhole);
  library.add(faUser);
  library.add(faUserPlus);
  library.add(faUserTag);
  library.add(faUsers);
  library.add(faWallet);
  library.add(faWarning);
  library.add(faWheelchair);
  library.add(faWrench);
  library.add(faXmark);
  library.add(faFileSlash);
  library.add(faFileContract);
  library.add(faMessagesQuestion);
  library.add(faSparkles);
  library.add(faHandHoldingDollar);
  library.add(faMoneyBillTrendUp);
  library.add(faEuroSign);
  library.add(faArrowsRepeat);
  dom.i2svg();
  dom.watch();
});
